import { XInput } from '@playcastdotio/CoreTypes';
import clsx from 'clsx';

interface GamepadStateProps {
  prefix: string;
  gamepad: XInput;
  value: number;
}

export const ButtonBumper = (props: GamepadStateProps) => {
  const { gamepad, prefix, value } = props;
  const isPressed = gamepad.wButtons & value;
  const fillColor = isPressed ? `rgba(250, 204, 21, 255)` : 'black';
  const isLeft = prefix.includes('left');

  return (
    <svg
      width='90'
      height='52'
      viewBox='0 0 90 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(isPressed ? 'drop-shadow-[0_0_10px_rgba(250,204,21,0.75)]' : '')}
    >
      <g filter='url(#filter0_d_308_19943)'>
        <rect
          id={prefix.concat('ButtonBumper')}
          x={isLeft ? '-42' : '4'}
          width='128'
          height='44'
          rx='22'
          fill={fillColor}
          fillOpacity='0.75'
        />
        <rect x={isLeft ? '-41' : '5'} y='1' width='126' height='42' rx='21' stroke='white' strokeOpacity='0.75' strokeWidth='2' />
        <path
          className='pointer-events-none'
          d={
            isLeft
              ? 'M47.1325 29V14.4545H48.8938V27.4375H55.6552V29H47.1325ZM58.3825 29V14.4545H63.4677C64.4809 14.4545 65.3166 14.6297 65.9748 14.9801C66.6329 15.3258 67.123 15.7921 67.445 16.3793C67.7669 16.9616 67.9279 17.608 67.9279 18.3182C67.9279 18.9432 67.8166 19.4593 67.5941 19.8665C67.3763 20.2737 67.0875 20.5956 66.7276 20.8324C66.3725 21.0691 65.9866 21.2443 65.57 21.358V21.5C66.015 21.5284 66.4625 21.6847 66.9123 21.9688C67.3621 22.2528 67.7385 22.66 68.0415 23.1903C68.3446 23.7206 68.4961 24.3693 68.4961 25.1364C68.4961 25.8655 68.3304 26.5213 67.9989 27.1037C67.6675 27.6861 67.1443 28.1477 66.4293 28.4886C65.7144 28.8295 64.784 29 63.6381 29H58.3825ZM60.1438 27.4375H63.6381C64.7887 27.4375 65.6055 27.215 66.0884 26.7699C66.5761 26.3201 66.82 25.7756 66.82 25.1364C66.82 24.6439 66.6945 24.1894 66.4435 23.7727C66.1926 23.3513 65.8351 23.0152 65.3711 22.7642C64.9071 22.5085 64.3578 22.3807 63.7234 22.3807H60.1438V27.4375ZM60.1438 20.8466H63.4109C63.9412 20.8466 64.4194 20.7424 64.8455 20.5341C65.2764 20.3258 65.6173 20.0322 65.8683 19.6534C66.1239 19.2746 66.2518 18.8295 66.2518 18.3182C66.2518 17.679 66.0292 17.1368 65.5842 16.6918C65.1391 16.242 64.4336 16.017 63.4677 16.017H60.1438V20.8466Z'
              : 'M21.861 29V14.4545H26.7757C27.9121 14.4545 28.8449 14.6487 29.574 15.0369C30.3032 15.4205 30.843 15.9484 31.1934 16.6207C31.5437 17.2931 31.7189 18.0578 31.7189 18.9148C31.7189 19.7718 31.5437 20.5317 31.1934 21.1946C30.843 21.8575 30.3056 22.3783 29.5811 22.7571C28.8567 23.1312 27.931 23.3182 26.8042 23.3182H22.8269V21.7273H26.7473C27.5239 21.7273 28.1489 21.6136 28.6223 21.3864C29.1006 21.1591 29.4462 20.8371 29.6593 20.4205C29.8771 19.9991 29.986 19.4972 29.986 18.9148C29.986 18.3324 29.8771 17.8234 29.6593 17.3878C29.4415 16.9522 29.0935 16.616 28.6152 16.3793C28.137 16.1378 27.5049 16.017 26.7189 16.017H23.6223V29H21.861ZM28.7076 22.4659L32.2871 29H30.2417L26.7189 22.4659H28.7076ZM34.6539 29V14.4545H39.7392C40.7524 14.4545 41.5881 14.6297 42.2463 14.9801C42.9044 15.3258 43.3945 15.7921 43.7164 16.3793C44.0384 16.9616 44.1994 17.608 44.1994 18.3182C44.1994 18.9432 44.0881 19.4593 43.8656 19.8665C43.6478 20.2737 43.359 20.5956 42.9991 20.8324C42.644 21.0691 42.2581 21.2443 41.8414 21.358V21.5C42.2865 21.5284 42.734 21.6847 43.1838 21.9688C43.6336 22.2528 44.01 22.66 44.313 23.1903C44.6161 23.7206 44.7676 24.3693 44.7676 25.1364C44.7676 25.8655 44.6019 26.5213 44.2704 27.1037C43.939 27.6861 43.4158 28.1477 42.7008 28.4886C41.9859 28.8295 41.0555 29 39.9096 29H34.6539ZM36.4153 27.4375H39.9096C41.0602 27.4375 41.877 27.215 42.3599 26.7699C42.8476 26.3201 43.0914 25.7756 43.0914 25.1364C43.0914 24.6439 42.966 24.1894 42.715 23.7727C42.4641 23.3513 42.1066 23.0152 41.6426 22.7642C41.1786 22.5085 40.6293 22.3807 39.9949 22.3807H36.4153V27.4375ZM36.4153 20.8466H39.6824C40.2127 20.8466 40.6909 20.7424 41.117 20.5341C41.5479 20.3258 41.8888 20.0322 42.1397 19.6534C42.3954 19.2746 42.5233 18.8295 42.5233 18.3182C42.5233 17.679 42.3007 17.1368 41.8556 16.6918C41.4106 16.242 40.7051 16.017 39.7392 16.017H36.4153V20.8466Z'
          }
          fill='white'
          fillOpacity='0.75'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_308_19943'
          x='-46'
          y='0'
          width='136'
          height='52'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_308_19943' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_308_19943' result='shape' />
        </filter>
      </defs>
    </svg>
  );
};

